export const songsdata = [
    {
        "title": "Enya-Boadicea",
        "url": "../sounds/boadicea.mp3"
    },
    {
        "title": "Moby: Times Up",
        "url": "../sounds/timesup.mp3"
    },
    {
        "title": "Moby: Ever-Loving",
        "url": "../sounds/everloving.mp3"
    },
    {
        "title": "Moby: GOD Moving Over the Face of the Water",
        "url": "../sounds/GODmovingover.mp3"
    },
    {
        "title": "Moby: First Cool Hive",
        "url": "../sounds/firstcoolhive.mp3"
    },
    {
        "title": "Moby: Flying Foxes",
        "url": "../sounds/flyingfoxes.mp3"
    },
    {
        "title": "GOD Within: Rain Cry",
        "url": "../sounds/raincry.mp3"
    },
    {
        "title": "Enya: Only Time",
        "url": "../sounds/onlytime.mp3"
    },
    {
        "title": "Delerium: Silence",
        "url": "../sounds/silence.mp3"
    },
    {
        "title": "Fortran 5: Time to Dream",
        "url": "../sounds/timetodream.mp3"
    }
]

export const spaceSoundFX = [
    {
        "title": "Space Drone FX",
        "url": "../sounds/dronefx.mp3"
    },
    {
        "title": "Space Drone FX",
        "url": "../sounds/dronefx2.mp3"
    },
    {
        "title": "Space Drone FX",
        "url": "../sounds/dronefx2.mp3"
    },
    {
        "title": "Space Drone FX",
        "url": "../sounds/dronefx2.mp3"
    }

]

